export const devices = [
	{
		option: "screenshotsAppleXsMax",
		title: "iPhone XS Max",
	},
	{
		option: "screenshotsApple6sPlus",
		title: "iPhone 6s Plus",
	},
	{
		option: "screenshotsAppleiPadGen2",
		title: "iPad Gen 2",
	},
	{
		option: "screenshotsAppleiPadGen3",
		title: "iPad Gen 3",
	},
	{
		option: "screenshotsAndroid",
		title: "Android",
	},
];
